<template>
  <div class="page-content OnlineBooking">
    <h1 class="page-title">会員会費 決済サマリー</h1>

    <el-form :model="search" :rules="rules" ref="searchFormRef">
      <el-row :gutter="10" class="search-area">
        <el-col :span="6">
          <el-form-item prop="brandIds">
            <el-select v-model="search.brandIds" multiple clearable>
              <el-option disabled value="-1" class="disable">
                <el-row class="select-handle" style="font-size: 16px;">
                  <el-col :span="6">
                    <div @click="selectHandler('select')" class="action">
                      <a class="el-icon-check"></a>
                      {{ $locale("global.selectAll") }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div @click="selectHandler('empty')" class="action">
                      <a class="el-icon-close"></a>
                      {{ $locale("global.deselectAll") }}
                    </div>
                  </el-col>
                </el-row>
              </el-option>
              <el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <!-- <RemoteSelectV2
              type="cinema"
              :list="comCinemaList"
              v-model="search.cinemaIds"
              :isMultiple="true"
              :isSelectAllFunc="true"
              @selectAll="arr => search.cinemaIds = arr"
              :formValue.sync="search.cinemaIds"
              @setList="arr => comCinemaList = arr"
              :fields="['id', 'name']"
            /> -->

          </el-form-item>
        </el-col>
        <el-col :span="14">
          <DatePickerGroup v-model="search.filterDateObj" :showWeekly="true" :startPickerOptions="datePickerOptions"
            :endPickerOptions="datePickerOptions" />
          <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
        </el-col>
        <el-col :span="4" class="ta-r">
          <el-button :disabled="tableData.length ? false : true" @click="downloadCsv" class="egl-btn-yellow">{{
            $locale("global.exportToCSV")
            }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <!-- Table -->
    <div class="custom-border-table preSalesDailyDataTable">
      <el-table class="egl-table list-table" style="width: 100%" :data="tableData" :border="true">
        <el-table-column prop="brandName"></el-table-column>
        <el-table-column label="システム利用料" prop="systemFee">
          <template slot-scope="scope">
            {{ scope.row.systemFee | currencyFormat }}
          </template>
        </el-table-column>
        <el-table-column label="取引枚数(新规·更新合計)" prop="count"></el-table-column>
        <el-table-column label="売上合計" prop="totalAmount">
          <template slot-scope="scope">
            {{ scope.row.totalAmount | currencyFormat }}
          </template>
        </el-table-column>
        <el-table-column label="visa/master手数料" prop="totalAmountFee">
          <template slot-scope="scope">
            {{ scope.row.totalAmountFee | currencyFormat }}
          </template>
        </el-table-column>
        <el-table-column label="GMO処理料(卜ランザクション·売上)" prop="gmoFee">
          <template slot-scope="scope">
            {{ scope.row.gmoFee | currencyFormat }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import DatePickerGroup from "@/components/common/CommDatePickerGroup/DatePickerGroup.vue";
import { getBrandList } from "@/helpers/service/api/brand";
import { toThousands } from "../../utils/common";

import { getMembershipFeeSalesReportService } from "@/helpers/service/api/onlineBooking";
import { exportCSV_fn } from "@/assets/js/membershipFees_exportCSV";
export default {
  data() {
    return {
      search: {
        brandIds: [],
        filterDateObj: {
          startDate: this.$moment().startOf("day").valueOf(),
          endDate: this.$moment().startOf("day").valueOf(),
        },
      },
      brandList: [],
      tableData: [],
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      rules: {
        brandIds: [
          {
            required: true,
            message: "ブランド" + this.$locale("form.plsSelect"),
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.getBrandList();
  },
  filters: {
    currencyFormat(value) {
      return value !== null && value !== undefined ? "¥" + toThousands(value) : "";
    },
  },
  methods: {
    getBrandList() {
      getBrandList({
        page: 0,
        pageSize: 99999,
      }).then(res => {
        this.brandList = res.data.data;
      });
    },
    dateDisableDate(time) {
      return time.getTime() > this.$moment().valueOf();
    },
    downloadCsv() {
      exportCSV_fn(this.tableData, this.search.filterDateObj.startDate, this.search.filterDateObj.endDate);
    },
    search_fn() {
      getMembershipFeeSalesReportService({
        brandIds: this.search.brandIds,
        startTime: this.$moment(this.search.filterDateObj.startDate).startOf("day").valueOf(),
        endTime: this.$moment(this.search.filterDateObj.endDate).add(1, "days").startOf("day").valueOf(),
      }).then(res => {
        if (!res.data.brandFeeList) {
          this.tableData = [];
          return;
        }
        this.tableData = res.data.brandFeeList;
      });
    },
    // 全选/反选cinema
    selectHandler(act) {
      this.search.brandIds = act === "select" ? this.brandList.map(item => item.id) : [];
    },
  },
  components: {
    DatePickerGroup,
  },
};
</script>
<style lang="scss" scoped>
.disable {
  cursor: pointer !important;
}

.action:hover {
  font-weight: 600;
  color: #F9B749;

  a {
    color: #F9B749;
  }
}
</style>